module.exports = "https://www.gc-qa.gnp.com.mx/233bae555799feabd84a7957fd4cc2f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/warning-otp.svg
// module id = 8179
// module chunks = 0